module.exports = __webpack_public_path__ + "static/media/youtube.c4a34e9d.svg";